import { useState } from "react";
import { BrandButton } from "@/components/ui/BrandButton";
import { BrandInput } from "@/components/ui/BrandInput";
import { MapPin, Calendar, Music, ArrowRight } from "lucide-react";
import { toast } from "@/hooks/use-toast";
const InfoSection = () => {
  return <section id="info" className="py-20 md:py-28 px-6 bg-yacht-cream">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-h1 text-yacht-charcoal font-bold mb-3">
            What's the deal?
          </h2>
          <p className="text-lg text-muted-foreground">
            Everything you need to know about Detroit's smoothest event.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-14 h-14 rounded-full bg-yacht-blue/10 flex items-center justify-center mx-auto mb-4">
              <Calendar className="w-7 h-7 text-yacht-blue" />
            </div>
            <h3 className="text-xl font-semibold text-yacht-charcoal mb-2">When</h3>
            <p className="text-muted-foreground">
              July 17–18, 2026<br />
              <span className="text-sm">The Roostertail</span>
            </p>
          </div>

          <div className="text-center">
            <div className="w-14 h-14 rounded-full bg-yacht-blue/10 flex items-center justify-center mx-auto mb-4">
              <MapPin className="w-7 h-7 text-yacht-blue" />
            </div>
            <h3 className="text-xl font-semibold text-yacht-charcoal mb-2">Where</h3>
            <p className="text-muted-foreground">
              Detroit, MI<br />
              <span className="text-sm">100 Marquette Dr</span>
            </p>
          </div>

          <div className="text-center">
            <div className="w-14 h-14 rounded-full bg-yacht-blue/10 flex items-center justify-center mx-auto mb-4">
              <Music className="w-7 h-7 text-yacht-blue" />
            </div>
            <h3 className="text-xl font-semibold text-yacht-charcoal mb-2">What</h3>
            <p className="text-muted-foreground">
              Live yacht rock<br />
              <span className="text-sm">All the smooth hits</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
};
const LineupSection = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setIsSubmitting(true);
    await new Promise(resolve => setTimeout(resolve, 1000));
    toast({
      title: "You're on the list!",
      description: "We'll keep you posted on all the latest updates."
    });
    setEmail("");
    setIsSubmitting(false);
  };
  return null;
};
const TicketCTA = () => {
  return null;
};
export { InfoSection, LineupSection, TicketCTA };